export default class TaxiRentDto {
  modelName: string;

  hours: number;
}
